/**  */
const userDropdown = () => {
	let timer;
	const user = document.querySelector('.user-menu');
	const userMobile = document.querySelector('.user-menu-mobile');
	const userBtn = document.querySelector('.user-menu__btn');
	const userMobileBtn = document.querySelector('.user-menu-mobile__btn');

	if (user && userBtn) {
		userBtn.addEventListener('click', () => {
			user.classList.toggle('is-open');
		});

		document.addEventListener('click', e => {
			if (!e.target.classList.contains('user-menu__btn') && !e.target.classList.contains('user-menu__item')) {
				user.classList.remove('is-open');
			}
		});

		window.addEventListener('resize', () => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				user.classList.remove('is-open');
			}, 300);
		});
	}
	if (userMobile && userMobileBtn) {
		userMobileBtn.addEventListener('click', () => {
			userMobile.classList.toggle('is-open');
		});

		document.addEventListener('click', e => {
			if (!e.target.classList.contains('user-menu-mobile__btn') && e.target.classList.contains('user-menu__dropdown')) {
				userMobile.classList.remove('is-open');
			}
		});

		window.addEventListener('resize', () => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				userMobile.classList.remove('is-open');
			}, 300);
		});
	}
	window.$('.menu__item.dropdown-menu').click((e) => {
		e.currentTarget.classList.toggle('is-open');
	});
};
// eslint-disable-next-line require-jsdoc
const successDropdown = () => {
	let timer;
	const user = document.querySelector('.success-menu');
	const userBtn = document.querySelector('.success-menu__btn');

	if (user && userBtn) {
		userBtn.addEventListener('click', () => {
			user.classList.toggle('is-open');
		});

		document.addEventListener('click', e => {
			if (!e.target.classList.contains('success-menu__btn') && !e.target.classList.contains('success-menu__item')) {
				user.classList.remove('is-open');
			}
		});

		window.addEventListener('resize', () => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				user.classList.remove('is-open');
			}, 300);
		});
	}
};

/**  */
const menuOpen = () => {
	let timer;
	const btn = document.querySelector('.hamburger');
	const menu = document.querySelector('.menu-wrapper');

	if (btn && menu) {
		btn.addEventListener('click', e => {
			btn.classList.toggle('is-active');
			menu.classList.toggle('is-active');
		});

		/**  */
		const removeActive = () => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				btn.classList.remove('is-active');
				menu.classList.remove('is-active');
			}, 300);
		};

		// window.addEventListener('resize', removeActive);
	}
};
/**  */
const menuProfileOpen = () => {
	let timer;
	const btn = document.querySelector('.user-menu-mobile__btn');
	const menu = document.querySelector('.menu-wrapper-mobile');

	if (btn && menu) {
		btn.addEventListener('click', e => {
			btn.classList.toggle('is-active');
			menu.classList.toggle('is-active');
		});

		/**  */
		const removeActive = () => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				btn.classList.remove('is-active');
				menu.classList.remove('is-active');
			}, 300);
		};

		// window.addEventListener('resize', removeActive);
	}
};

export { successDropdown, userDropdown, menuOpen, menuProfileOpen };
